import { toast } from 'react-toastify'
import { openInNewTab } from 'src/consumer/helpers/utilFunctions'
import { getMentalStateType } from 'src/consumer/services/featureServices'
import { postMPDataWithParams } from 'src/mentor/services'

export function showCustomCategoryTitle(activityObject, selectedCategory) {
  if (selectedCategory?.categoryType === 'quotes') {
    return !!activityObject?.activityId
  }
  return true
}

export function activityPlayerUrl(activityType, activityId, { setQuote, setQuoteDialogOpen }) {
  const itemId = activityId?.value
  const baseDomain = 'https://aumhum.com'
  // const baseDomain = 'http://localhost:3000'
  switch (activityType) {
    case 'course':
      return baseDomain + `/c/view/id/` + itemId
    case 'journal':
      return baseDomain + '/journal/id/' + itemId
    case 'quote':
      return true
    case 'article':
      return baseDomain + '/article/id/' + itemId
    case 'assessment':
      return baseDomain + '/assessments/id/' + itemId
    case 'practice':
      break
    case 'mental-state-type':
      return true
    default:
      break
  }
  return null
}

export async function handleActivityPlanClick(
  activityType,
  activityId,
  { setQuote, setQuoteDialogOpen, setShowMentalStateDialog, setMentalStateTypeData },
) {
  if (activityType !== 'quote' && activityType !== 'mental-state-type') {
    openInNewTab(activityPlayerUrl(activityType, activityId, { setQuote, setQuoteDialogOpen }))
  } else {
    switch (activityType) {
      case 'quote':
        setQuote({ ...activityId })
        setQuoteDialogOpen(true)
        break
      case 'mental-state-type':
        const resp = await getMentalStateType(activityId.value)
        if (resp.status === 200) {
          setMentalStateTypeData(resp.data)
          setShowMentalStateDialog(true)
        }
        break
      default:
        break
    }
  }
}

export async function SaveRestItem(dataToSubmit, mentorId) {
  const resp = await postMPDataWithParams('/api/secure/teacher/rest/save', dataToSubmit)
  if (resp.status === 200) {
    return resp
  } else {
    toast.error('Something went wrong! Please try again.')
  }
  return dataToSubmit
}
